// Formatação/normalização de rótulos usados nas telas (nome de cliente, id de
// recurso e rótulo de unidade). Puras de propósito: viviam no corpo do App.tsx, onde
// não davam para testar sem montar o DashboardApp inteiro.

export function firstName(nome: string): string {
  return nome.trim().split(/\s+/)[0] ?? ''
}

export function numericResourceId(id?: string | null): string | null {
  return id && /^\d+$/.test(id) ? id : null
}

export function splitLocationLabel(name: string, address?: string): { name: string; address?: string } {
  const [shortName, inlineAddress] = name.split(/\s+[—-]\s+/, 2)
  return { name: shortName || name, address: address || inlineAddress }
}

export function fullLocationLabel(name: string, address?: string): string {
  return address && address !== name ? `${name} — ${address}` : name
}
